/* Imports */
import React, { useState } from "react"
import { Paginator } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const PaginatorPage = () => {
    const [active, setActive] = useState(1)
    const handleNext = () => setActive(active + 1)
    const handlePrev = () => setActive(active - 1)
    const handleChange = e => {
        const pageNumber = parseInt(e.target.value)
        setActive(pageNumber > 30 ? 30 : pageNumber < 1 ? 1 : pageNumber)
    }

    const [activeRight, setActiveRight] = useState(1)
    const handleNextRight = () => setActiveRight(activeRight + 1)
    const handlePrevRight = () => setActiveRight(activeRight - 1)
    const handleChangeRight = e => {
        const pageNumber = parseInt(e.target.value)
        setActiveRight(pageNumber > 10 ? 10 : pageNumber < 1 ? 1 : pageNumber)
    }

    const items = [
        {
            title: "Left",
            content: (
                <Paginator
                    totalPages={30}
                    active={active}
                    handlePrev={handlePrev}
                    handleNext={handleNext}
                    handleChange={handleChange}
                    justify="left"
                />
            ),
            code: 'const [active, setActive] = useState(1)\nconst handleNext = () => setActive(active + 1)\nconst handlePrev = () => setActive(active - 1)\nconst handleChange = e => {\n    const pageNumber = parseInt(e.target.value)\n    setActive(pageNumber > 30 ? 30 : pageNumber < 1 ? 1 : pageNumber)\n}\n\n<Paginator\n    totalPages={30}\n    active={active}\n    handlePrev={handlePrev}\n    handleNext={handleNext}\n    handleChange={handleChange}\n    justify="left"\n/>',
        },
        {
            title: "Right",
            content: (
                <Paginator
                    totalPages={10}
                    active={activeRight}
                    handlePrev={handlePrevRight}
                    handleNext={handleNextRight}
                    handleChange={handleChangeRight}
                    idInput="paginator-right"
                    justify="right"
                />
            ),
            code: 'const [activeRight, setActiveRight] = useState(1)\nconst handleNextRight = () => setActiveRight(activeRight + 1)\nconst handlePrevRight = () => setActiveRight(activeRight - 1)\nconst handleChangeRight = e => {\n    const pageNumber = parseInt(e.target.value)\n    setActiveRight(pageNumber > 10 ? 10 : pageNumber < 1 ? 1 : pageNumber)\n}\n\n<Paginator\n    totalPages={10}\n    active={activeRight}\n    handlePrev={handlePrevRight}\n    handleNext={handleNextRight}\n    handleChange={handleChangeRight}\n    idInput="paginator-right"\n    justify="right"\n/>',
        },
    ]

    const propsItems = [
        {
            name: "handlePrev",
            type: "Function",
            required: "Yes",
        },
        {
            name: "handleNext",
            type: "Function",
            required: "Yes",
        },
        {
            name: "handleChange",
            type: "Function",
            required: "Yes",
        },
        {
            name: "active",
            type: "Number",
            example: "10",
            required: "Yes",
        },
        {
            name: "totalPages",
            type: "Number",
            example: "42",
            required: "Yes",
        },
        {
            name: "textPage",
            type: "String",
            example: "Seite",
            default: "Page",
        },
        {
            name: "textOf",
            type: "String",
            example: "de",
            default: "of",
        },
        {
            name: "iconPrev",
            type: "String",
            example: "arrow-left",
        },
        {
            name: "iconNext",
            type: "String",
            example: "arrow-right",
        },
        {
            name: "fajnyIconPrev",
            type: "String",
            example: "chevron-left-regular",
            possible: commonProps.fajnyIcons,
            default: "chevron-left-solid",
        },
        {
            name: "fajnyIconNext",
            type: "String",
            example: "chevron-right-solid",
            possible: commonProps.fajnyIcons,
            default: "chevron-right-solid",
        },
        {
            name: "idInput",
            type: "String",
            default: "paginator",
        },
        {
            name: "justify",
            type: "String",
            example: "right",
            possible: '"left" | "right"',
            default: "left",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default PaginatorPage
